import { beEmailMessageApiDeleteMessage, beEmailMessageApiSetSelfImport } from 'Api/beEmailMessageApi'
import { getPresignedUrlPutObject } from 'Api/beStorageApi'
import axios from 'axios'
import { storeGet } from 'Helpers/localStorage'
import { STORE_KEY_ID_LIST } from 'mailup-react-helpers'

export async function getPresignedUrlPut (expiresIn) {
  const resp = await getPresignedUrlPutObject(expiresIn)
  return resp
}

export async function setSelfImport (message) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const resp = await beEmailMessageApiSetSelfImport(idList, message)
  return resp
}

export async function uploadFile (url, file) {
  return new Promise((resolve, reject) => {
    var options = {
      headers: {
        'Content-Type': file.type
      }
    }
    axios.put(url.Url, file, options)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export async function deleteMessage (idMessage) {
  const resp = await beEmailMessageApiDeleteMessage(idMessage)
  return resp
}
